/** Ask for a data export (block 33). Invalidates nothing: the result is an email, not server state. */
import { useMutation } from "@tanstack/react-query";
import { getNookClient } from "../client.js";
export function useRequestExport() {
    return useMutation({ mutationFn: () => getNookClient().requestExport() });
}
//# sourceMappingURL=use-request-export.js.map